import React from 'react';
import './css/GitRoots.css';

const W = 1440;
const H = 900;

const L = {
    main: W * 0.50,
    feat1: W * 0.30,
    feat2: W * 0.70,
    hotfix: W * 0.16,
    rel: W * 0.84,
};

const MY = H * 0.50; // midpoint — git ends, roots begin

const commits = [
    { id: 'c1', x: L.main, y: H * 0.04, lane: 'main' },
    { id: 'c2', x: L.main, y: H * 0.16, lane: 'main' },
    { id: 'c3', x: L.main, y: H * 0.30, lane: 'main' },
    { id: 'c4', x: L.main, y: H * 0.44, lane: 'main' },

    { id: 'f1', x: L.feat1, y: H * 0.20, lane: 'feat1' },
    { id: 'f2', x: L.feat1, y: H * 0.32, lane: 'feat1' },
    { id: 'f3', x: L.feat1, y: H * 0.42, lane: 'feat1' },

    { id: 'g1', x: L.feat2, y: H * 0.22, lane: 'feat2' },
    { id: 'g2', x: L.feat2, y: H * 0.36, lane: 'feat2' },

    { id: 'h1', x: L.hotfix, y: H * 0.26, lane: 'hotfix' },
    { id: 'h2', x: L.hotfix, y: H * 0.38, lane: 'hotfix' },

    { id: 'r1', x: L.rel, y: H * 0.24, lane: 'rel' },
    { id: 'r2', x: L.rel, y: H * 0.38, lane: 'rel' },
];

const gitEdges = [
    ['c1', 'c2'], ['c2', 'c3'], ['c3', 'c4'],
    ['c2', 'f1'], ['f1', 'f2'], ['f2', 'f3'], ['f3', 'c4'],
    ['c2', 'g1'], ['g1', 'g2'], ['g2', 'c4'],
    ['f1', 'h1'], ['h1', 'h2'], ['h2', 'c3'],
    ['c2', 'r1'], ['r1', 'r2'], ['r2', 'c3'],
];

const commitLabels = {
    c1: 'init',
    c2: 'feat: scaffold',
    f1: 'feat/auth',
    g1: 'feat/ui',
    h1: 'fix: hotfix',
    r1: 'release/v2',
    c4: 'HEAD',
};

const laneColor = {
    main: [109, 86, 255],
    feat1: [44, 154, 44],
    feat2: [220, 120, 40],
    hotfix: [220, 60, 60],
    rel: [80, 180, 220],
};

function lc(lane, a = 0.7) {
    const [r, g, b] = laneColor[lane] ?? [255, 255, 255];
    return `rgba(${r},${g},${b},${a})`;
}

const commitMap = Object.fromEntries(commits.map(c => [c.id, c]));

// roots: [sx, sy, cp1x, cp1y, cp2x, cp2y, ex, ey, opacity, delayS, strokeW]
const roots = [
    [W * .50, MY, W * .40, MY + 90, W * .24, MY + 200, W * .14, MY + 340, 0.7, 0.0, 2.5],
    [W * .50, MY, W * .60, MY + 90, W * .76, MY + 200, W * .86, MY + 340, 0.7, 0.1, 2.5],
    [W * .50, MY, W * .47, MY + 110, W * .44, MY + 240, W * .42, MY + 400, 0.5, 0.2, 1.8],
    [W * .50, MY, W * .53, MY + 110, W * .56, MY + 240, W * .58, MY + 400, 0.5, 0.2, 1.8],

    [W * .14, MY + 340, W * .08, MY + 380, W * .03, MY + 410, W * .00, MY + 440, 0.6, 0.5, 1.8],
    [W * .14, MY + 340, W * .12, MY + 390, W * .10, MY + 430, W * .06, MY + 460, 0.4, 0.6, 1.3],
    [W * .14, MY + 340, W * .20, MY + 380, W * .18, MY + 415, W * .22, MY + 450, 0.35, 0.7, 1.1],

    [W * .86, MY + 340, W * .92, MY + 380, W * .97, MY + 410, W * 1.0, MY + 440, 0.6, 0.5, 1.8],
    [W * .86, MY + 340, W * .88, MY + 390, W * .90, MY + 430, W * .94, MY + 460, 0.4, 0.6, 1.3],
    [W * .86, MY + 340, W * .80, MY + 380, W * .82, MY + 415, W * .78, MY + 450, 0.35, 0.7, 1.1],

    [W * .42, MY + 400, W * .34, MY + 430, W * .24, MY + 455, W * .18, MY + 490, 0.35, 0.8, 1.0],
    [W * .58, MY + 400, W * .66, MY + 430, W * .76, MY + 455, W * .82, MY + 490, 0.35, 0.8, 1.0],

    [W * .06, MY + 460, W * .03, MY + 470, W * .01, MY + 480, W * .00, MY + 490, 0.25, 1.0, 0.8],
    [W * .94, MY + 460, W * .97, MY + 470, W * .99, MY + 480, W * 1.0, MY + 490, 0.25, 1.0, 0.8],
];

function rPath([sx, sy, cp1x, cp1y, cp2x, cp2y, ex, ey]) {
    return `M ${sx} ${sy} C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${ex} ${ey}`;
}
function rLen([sx, sy, , , , , ex, ey]) {
    return Math.hypot(ex - sx, ey - sy) * 1.6;
}
function rc(opacity) {
    return `rgba(180, 130, 70, ${opacity})`;
}

const GitToRoots = () => (
    <>
        <div className="gtr-wrap">
            <svg
                viewBox={`0 0 ${W} ${H}`}
                preserveAspectRatio="xMidYTop meet"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    {/* trunk colour transition: purple → earthy */}
                    <linearGradient id="gtrTrunk" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="rgba(109,86,255,0.8)" />
                        <stop offset="100%" stopColor="rgba(180,130,70,0.8)" />
                    </linearGradient>
                </defs>

                {/* ── GIT EDGES ── */}
                {gitEdges.map(([fromId, toId], i) => {
                    const a = commitMap[fromId];
                    const b = commitMap[toId];
                    if (!a || !b) return null;
                    const isCurve = a.x !== b.x;
                    const d = isCurve
                        ? `M ${a.x} ${a.y} C ${a.x} ${(a.y + b.y) / 2}, ${b.x} ${(a.y + b.y) / 2}, ${b.x} ${b.y}`
                        : `M ${a.x} ${a.y} L ${b.x} ${b.y}`;
                    const len = isCurve
                        ? Math.hypot(b.x - a.x, b.y - a.y) * 1.3
                        : Math.abs(b.y - a.y);
                    return (
                        <path key={`ge${i}`} d={d} fill="none"
                            stroke={lc(a.lane, 0.7)}
                            strokeWidth="1.8"
                            className="gtr-edge"
                            style={{ '--len': len, '--delay': `${0.05 + i * 0.07}s` }}
                        />
                    );
                })}

                {/* ── TRANSITION TRUNK ── */}
                <path
                    d={`M ${L.main} ${H * 0.44} L ${L.main} ${MY}`}
                    fill="none"
                    stroke="url(#gtrTrunk)"
                    strokeWidth="2"
                    className="gtr-edge"
                    style={{ '--len': Math.abs(MY - H * 0.44), '--delay': '1.0s' }}
                />

                {/* ── COMMIT DOTS + LABELS ── */}
                {commits.map((c, i) => {
                    const isHead = c.id === 'c4';
                    const isMerge = c.id === 'c3';
                    const label = commitLabels[c.id];
                    const color = lc(c.lane, 0.75);
                    const delay = `${0.6 + i * 0.07}s`;
                    const onLeft = c.x < W * 0.38;
                    const onRight = c.x > W * 0.62;
                    const labelX = onLeft ? c.x + 14 : onRight ? c.x - 14 : c.x < W / 2 ? c.x - 14 : c.x + 14;
                    const anchor = onLeft ? 'start' : onRight ? 'end' : c.x < W / 2 ? 'end' : 'start';
                    return (
                        <g key={c.id}>
                            {(isHead || isMerge) && (
                                <circle cx={c.x} cy={c.y} r={10}
                                    fill="none" stroke={color} strokeWidth="1" opacity="0.35"
                                    className="gtr-dot" style={{ '--delay': delay }} />
                            )}
                            <circle cx={c.x} cy={c.y} fill={color}
                                className={isHead ? 'gtr-dot gtr-dot--head' : 'gtr-dot'}
                                style={{ '--delay': delay }}
                            />
                            {label && (
                                <text x={labelX} y={c.y + 4}
                                    textAnchor={anchor} fill={color}
                                    className="gtr-label"
                                    style={{ '--delay': `${parseFloat(delay) + 0.12}s` }}
                                >{label}</text>
                            )}
                        </g>
                    );
                })}

                {/* ── ROOTS ── */}
                {roots.map((r, i) => {
                    const [, , , , , , , , opacity, delay, sw = 1.2] = r;
                    return (
                        <path key={`r${i}`}
                            d={rPath(r)} fill="none"
                            stroke={rc(opacity)}
                            strokeWidth={sw}
                            strokeLinecap="round"
                            className="gtr-root"
                            style={{ '--len': rLen(r), '--delay': `${1.2 + delay}s` }}
                        />
                    );
                })}

                {/* root tip dots */}
                {roots.slice(0, 8).map((r, i) => {
                    const [, , , , , , ex, ey, opacity, delay] = r;
                    return (
                        <circle key={`rd${i}`} cx={ex} cy={ey} r={3}
                            fill={rc(opacity * 0.9)}
                            className="gtr-root-dot"
                            style={{ '--delay': `${1.2 + delay + 1.8}s` }}
                        />
                    );
                })}
            </svg>
        </div>
    </>
);

export default GitToRoots;